import jwt from 'jsonwebtoken';
import { push } from 'connected-react-router';
import trace from '../../../helpers/trace';
import {
  ActualizarDatosUsuario,
  loading,
  openCloseToast,
  sendEmailApp,
  openCloseTourConfirmation,
  setUserProfile,
  setUserAccessList,
  setComanyList,
  setCompanyId,
  setUserFunctionalities,
} from '../../Global/actions';
import {
  LoginUserApi,
  ValidateTokenApi,
  LoginUserTempApi,
  GetEmailTokenApi,
  RefreshTokenApi,
} from '../../../services/loginApi';
import { validateRutApi, validateEmailApi, validateUser } from '../../../services/registroApi';
import { paths } from '../../../config/routes';
import validaciones from '../../../helpers/validaciones';
import { getUserFunctionalitiesApi } from '../../../services/funcionalidadesApi';
import { SetDefaultNotificationsForUser } from '../../../services/NotificacionesApi';
import { validateUserWOCompany, showMessageUserWOCompany } from './validateUserWOCompany';
import { AtSomeIframeSSOPage, isIframe } from 'helpers/isIframe';
import Rut from 'helpers/rut.lib';
import { SELECTION_SUCCESS, WANT_TO_BE_REDIRECTED } from '../Selection/types';
import { whiteListAPI } from 'services/selectionApi';
import { setExpirationAccessTokenDate } from 'helpers/setExpirationAccessTokenDate.lib';

export const fullScreenLoading = (isLoading, unblock = false) => ({
  type: 'FULL_SCREEN_LOADING',
  isLoading:
    isIframe && !isLoading ? (unblock || AtSomeIframeSSOPage() ? isLoading : true) : isLoading,
});

export const doResetState = () => ({
  type: 'RESET_STATE',
});

export const setDataLogin = (data) => ({
  type: 'SET_DATA_LOGIN',
  data,
});
export const setDataActiveUser = (activeUser) => ({
  type: 'SET_DATA_ACTIVE_USER',
  activeUser,
});
export const setMessageLogin = (message) => ({
  type: 'SET_MESSAGE_LOGIN',
  message,
});

export const resetLoginState = () => ({
  type: 'RESET_LOGIN_STATe',
});

export const showPassInput = (show, isAccountTemp) => ({
  type: 'SET_SHOW_PASS',
  show,
  isAccountTemp,
});

export const disableButton = (disable) => ({
  type: 'DISABLE_BUTTON',
  disable,
});

export const accountIsActive = (isActive) => ({
  type: 'ACCOUNT_IS_ACTIVE',
  isActive,
});

export const doLoginTemp = (loginData) => async (dispatch) => {
  if (loginData.AuthType === 'RUN') {
    loginData.Username = validaciones.formatRut(loginData.Username, {
      showDots: false,
      showHyphen: true,
    });
  }
  const responseTemp = await LoginUserTempApi(loginData);
  if (responseTemp.status === 200) {
    const resultTemp = await responseTemp.json();
    if (resultTemp.Success) {
      resultTemp.User.AccessToken = null;
      resultTemp.User.RefreshToken = null;
      resultTemp.User.LoginSuccess = true;
      resultTemp.User.TempBD = true;
      resultTemp.User.DateLogIn = new Date();
      // Guardar la data en el localstorge, actualizar UserData del estado global agregando el flag UserTemp = true

      const token = jwt.sign(resultTemp.User, 'secret', {
        expiresIn: '15m',
      });
      localStorage.setItem('token', token);
      localStorage.removeItem('AccessToken');
      localStorage.removeItem('RefreshToken');

      dispatch(ActualizarDatosUsuario(resultTemp.User));
      dispatch(resetLoginState());
    } else {
      dispatch(showPassInput(true));
      dispatch(disableButton(true));
      dispatch(setMessageLogin('Ingreso inválido, comprueba la contraseña'));
    }
  } else {
    dispatch(showPassInput(true));
    dispatch(disableButton(true));
    dispatch(setMessageLogin('Ingreso inválido, comprueba la contraseña'));
  }
};

export const getDataUserAd = async (result) => {
  const userData = {};
  const responseRut = await validateRutApi(result.RUT);

  let resultRut = null;
  if (responseRut.ok) {
    resultRut = await responseRut.json();
    const array = resultRut.User.FullName.split(' ');
    userData.FirstName = array[0];
    userData.LastName = array[1];
  }
  return userData;
};

export const doResendActivation = (userData, loginData) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let email;
    if (userData.SignInNameType === 'emailAddress') {
      email = userData.SignInNameValue;
    } else if (loginData.AuthType === 'EMAIL') {
      email = loginData.UserName;
    }

    const response = await GetEmailTokenApi(email);
    if (response.status === 200) {
      const result = await response.json();
      if (result.Success) {
        const responseEmail = await validateEmailApi(email);
        if (responseEmail.status === 200) {
          const hostname = window && window.location && window.location.hostname;
          const uriMail =
            hostname === 'localhost' ? 'http://localhost:3001' : `https://${hostname}`;

          const href = `${uriMail}/activarCuenta/${result.EmailToken}`;
          const parametersMail = {};
          const resultMail = await responseEmail.json();
          parametersMail.userInfo = {
            FirstName: resultMail.User.FullName,
            LastName: '',
            Email: resultMail.User.SignInNameValue,
            Rut: resultMail.User.Rut,
            href,
          };
          parametersMail.templateMail = 'activaUsuario';
          await dispatch(sendEmailApp(parametersMail));
        } else {
          dispatch(
            openCloseToast({
              isToastOpen: true,
              typeStyle: 'error',
              msgToast: 'No se ha podido enviar el correo',
              displayTime: 1000,
            }),
          );
        }

        //
        // await dispatch(doSendMailUser({
        //   FirstName: userData.FullName,
        //   LastName: "",
        //   Email: email,
        //   Rut: "",
        // }, result.EmailToken, true));
      }
    }
  } catch (e) {
    dispatch(
      openCloseToast({
        isToastOpen: true,
        typeStyle: 'error',
        msgToast: 'Error al Reenviar el correo de activacion',
        displayTime: 1000,
      }),
    );
  }
  dispatch(loading(false));
};

export const doValidation = (loginData) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const username =
      loginData.AuthType === 'EMAIL'
        ? loginData.Username
        : validaciones.formatRut(loginData.Username, {
            showDots: false,
            showHyphen: true,
          });
    const response = await validateUser(username, loginData.AuthType);
    if (response.status === 200) {
      const result = await response.json();
      if (result.Success) {
        if (result.User.AccountType !== 'Temporal') {
          if (result.User.AccountEnabled === false) {
            // account not active
            dispatch(setDataActiveUser(result.User));
            dispatch(showPassInput(true));
            dispatch(disableButton(false));
            dispatch(accountIsActive(false));
          } else {
            // account is AD
            dispatch(showPassInput(true, false));
            dispatch(disableButton(true));
          }
        } else {
          dispatch(showPassInput(true, true));
          dispatch(disableButton(true));
        }
      } else {
        throw response;
      }
    } else {
      throw response;
    }
  } catch (e) {
    dispatch(showPassInput(false, false));
    dispatch(disableButton(true));
    dispatch(setMessageLogin('Ingreso inválido, comprueba el rut o mail'));
  }
  dispatch(loading(false));
};

export const doLogin = (loginData, isTemp) => async (dispatch) => {
  dispatch(loading(true));
  dispatch(fullScreenLoading(true));
  const toast = {};
  try {
    if (loginData.AuthType === 'RUN') {
      loginData.Username = validaciones.formatRut(loginData.Username, {
        showDots: false,
        showHyphen: true,
      });
    }
    loginData.LoginType = isTemp ? 'Temporal' : 'AD';
    const response = await LoginUserApi(loginData);
    const result = await response.json();

    /*     new Promise(() => {
      if(result && result.Menu && result.Menu.Functionalities.every(p => p.RolID === 8)) {
        if(window.localStorage.getItem(`${result.Usuario.User.Rut}rol_exachs_advertisement`) !== 'true') {
          setTimeout(() => {
            swal.confirm(null,
            <div>
              <br />
              <p style={{ fontSize: '.9em' }}>
                La empresa en la que trabajas ya no está adherida a la ACHS, por lo que solo tendrás acceso a la <b>sección Trabajador</b>
              </p>
            </div>
            );

            window.localStorage.setItem(`${result.Usuario.User.Rut}rol_exachs_advertisement`, 'true');
          }, 5000);
        }
      }
    }) */

    if (response.status === 200) {
      if (isTemp) {
        localStorage.setItem('token', result.AccessToken);
        localStorage.removeItem('AccessToken');
        localStorage.removeItem('RefreshToken');

        const { RUT, FirstName, Email, CellPhoneNumber, LastName, DateLogin } = jwt.verify(
          result.AccessToken,
          'SecretTemporalAccessToken',
        );

        dispatch(
          ActualizarDatosUsuario({
            AccessToken: null,
            LoginSuccess: true,
            RefreshToken: null,
            RUT,
            CellPhoneNumber,
            Email,
            FirstName,
            LastName,
            DateLogin,
            TempBD: true,
          }),
        );
        dispatch(resetLoginState());
        dispatch(fullScreenLoading(false));
      } else if (result.LoginSuccess) {
        const tokenInfo = jwt.decode(result.AccessToken);
        result.RUT = tokenInfo.extension_RUN;
        result.Email = tokenInfo.emails[0];
        if (tokenInfo.given_name) localStorage.setItem('FirstName', tokenInfo.given_name);
        if (tokenInfo.family_name) localStorage.setItem('LastName', tokenInfo.family_name);

        localStorage.setItem('AccessToken', result.AccessToken);
        localStorage.setItem('RefreshToken', result.RefreshToken);
        localStorage.removeItem('token');
        setExpirationAccessTokenDate(`Bearer ${result.AccessToken}`)

        result.FirstName = tokenInfo.given_name;
        result.LastName = tokenInfo.family_name;
        result.TempBD = false;

        dispatch(setComanyList(result.Companies));
        dispatch(setLoginUserFunctionalities(result.Menu));

        if (result.Companies && result.Companies.length > 0) {
          const companyId = result.Companies[0].RutEmpresa;
          const companyName = result.Companies[0].Nombre;
          if (companyId) {
            dispatch(setCompanyId(companyId, companyName));
          }
        } else {
          const ids = [];
          if (result.Menu && Array.isArray(result.Menu.Functionalities)) {
            result.Menu.Functionalities.forEach((func) => {
              ids.push(func.Code.trim());
            });
            dispatch(setUserFunctionalities(ids));
          }
          dispatch(fullScreenLoading(false));
        }

        const cleanRut = Rut.Clean(result.RUT, { removeCD: 1, keepHyphen: 0 });
        try {
          const response = await whiteListAPI(cleanRut);

          if (response.status === 200) {
            const result = await response.json();
            sessionStorage.setItem('listaBlanca', JSON.stringify(result));
            dispatch({
              type: SELECTION_SUCCESS,
              payload: result.exist,
            });

            if (result.exist && !result.isACHS) {
              dispatch({ type: WANT_TO_BE_REDIRECTED });
            }
          } else {
            const result = await response.json();
            const toast = {};
            toast.isToastOpen = true;
            toast.msgToast = result.message;
            toast.typeStyle = 'error';
            toast.displayTime = 1000;
            dispatch(openCloseToast(toast));
          }
        } catch (error) {
          console.log('Selection action error: ', error.response);
        }
        dispatch(ActualizarDatosUsuario(result));

        if (result.IsFirstLogin) {
          dispatch(openCloseTourConfirmation(true));
          await SetDefaultNotificationsForUser(result.RUT);
        }
        //validar usuario dependiente sin empresas asignadas.
        if (await validateUserWOCompany(result)) {
          await new Promise(() => showMessageUserWOCompany());
        }
      } else {
        dispatch(setMessageLogin('Ingreso inválido, comprueba la contraseña'));
        dispatch(fullScreenLoading(false));
      }
    } else if (response.status === 403) {
      dispatch(fullScreenLoading(false));
      dispatch(setMessageLogin('El usuario se encuentra bloqueado temporalmente'));
    } else if (response.status === 401) {
      dispatch(fullScreenLoading(false));
      dispatch(setMessageLogin(`${result.Message}`));
    } else {
      dispatch(fullScreenLoading(false));
      dispatch(setMessageLogin(`${result.Message}`));
    }
  } catch (error) {
    console.error(error);
    trace.error('doLogin', error);
    toast.isToastOpen = true;
    toast.msgToast = 'Error de conexión, intente mas tarde';
    toast.typeStyle = 'error';
    toast.displayTime = 1000;
    dispatch(fullScreenLoading(false));
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const setLoginUserFunctionalities = (menu) => async (dispatch) => {
  let perfil;

  if (menu) {
    dispatch(setUserAccessList(menu.Functionalities));
    if (Array.isArray(menu.Profiles)) {
      if (menu.Profiles.filter((item) => item.Name === 'Achs').length) {
        perfil = 'Achs';
      } else if (menu.Profiles.filter((item) => item.Name === 'Empresa').length) {
        perfil = 'Empresa';
      } else if (menu.Profiles.filter((item) => item.Name === 'Trabajador').length) {
        perfil = 'Trabajador';
      }
    }
  }

  dispatch(setUserProfile(perfil));
};

export const getUserFunctionalities = (userRut) => async (dispatch) => {
  try {
    const response = await getUserFunctionalitiesApi(userRut);
    if (response.status === 200) {
      const result = await response.json();
      let perfil;
      if (result.Success) {
        dispatch(setUserAccessList(result.Menu.Functionalities));
        if (Array.isArray(result.Menu.Profiles)) {
          if (result.Menu.Profiles.filter((item) => item.Name === 'Achs').length) {
            perfil = 'Achs';
          } else if (result.Menu.Profiles.filter((item) => item.Name === 'Empresa').length) {
            perfil = 'Empresa';
          } else if (result.Menu.Profiles.filter((item) => item.Name === 'Trabajador').length) {
            perfil = 'Trabajador';
          }
        }
      } else {
        dispatch(fullScreenLoading(false));
      }

      dispatch(setUserProfile(perfil));
    } else {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: 'Error al obtener las funcionalidades',
          typeStyle: 'error',
          displayTime: 5000,
        }),
      );
    }
  } catch (e) {
    console.error(e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: 'Error al obtener las funcionalidades',
        typeStyle: 'error',
        displayTime: 1000,
      }),
    );
  }
};

export const validateToken = () => async (dispatch) => {
  // dispatch(loading(true));
  try {
    const token = localStorage.getItem('token');
    let AccessToken = localStorage.getItem('AccessToken');
    let RefreshToken = localStorage.getItem('RefreshToken');

    if (AccessToken !== null && RefreshToken !== null && token == null) {
      dispatch(fullScreenLoading(true));
      const response = await ValidateTokenApi(AccessToken);
      if (response.status === 200) {
        const result = await response.json();
        let RUT;
        let Email;
        const FirstName = localStorage.getItem('FirstName');
        let LastName = localStorage.getItem('LastName');

        if (LastName === 'null') {
          LastName = null;
        }
        if (result.IsValid) {
          const tokenInfo = jwt.decode(AccessToken);
          RUT = tokenInfo.extension_RUN;
          Email = tokenInfo.emails[0];
          const refreshRequest = await RefreshTokenApi(RefreshToken);
          if (refreshRequest.status === 200) {
            const refreshResult = await refreshRequest.json();
            localStorage.setItem('AccessToken', refreshResult.AccessToken);
            localStorage.setItem('RefreshToken', refreshResult.RefreshToken);
            AccessToken = refreshResult.AccessToken;
            RefreshToken = refreshResult.RefreshToken;
            setExpirationAccessTokenDate(`Bearer ${refreshResult.AccessToken}`)
          }
          dispatch(getUserFunctionalities(RUT));
          dispatch(
            ActualizarDatosUsuario({
              AccessToken,
              LoginSuccess: true,
              FirstName,
              LastName,
              RefreshToken,
              RUT,
              Email,
              TempBD: false,
            }),
          );
        } else {
          dispatch(logout());
        }
      } else {
        dispatch(logout());
      }
    } else if (token !== null && AccessToken == null && RefreshToken == null) {
      const { RUT, FirstName, Email, CellPhoneNumber, LastName, DateLogin } = jwt.verify(
        token,
        'SecretTemporalAccessToken',
      );

      dispatch(
        ActualizarDatosUsuario({
          AccessToken: null,
          LoginSuccess: true,
          RefreshToken: null,
          RUT,
          CellPhoneNumber,
          Email,
          FirstName,
          LastName,
          DateLogin,
          TempBD: true,
        }),
      );
    }
  } catch (error) {
    console.log('sesion expirada', error);
  }
  // dispatch(loading(false));
};

export const logout = () => async (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('AccessToken');
  localStorage.removeItem('RefreshToken');

  dispatch(push(paths.root));
  dispatch(doResetState());
};

export const doRefreshToken = (userData, refreshToken, resetTimerCallback) => async (dispatch) => {
  try {
    const request = await RefreshTokenApi(refreshToken);
    if (request.status === 200) {
      const result = await request.json();
      if (result.LoginSuccess) {
        localStorage.setItem('AccessToken', result.AccessToken);
        localStorage.setItem('RefreshToken', result.RefreshToken);
        setExpirationAccessTokenDate(`Bearer ${result.AccessToken}`)

        const newUserData = { ...userData, ...result };
        dispatch(ActualizarDatosUsuario(newUserData));
        resetTimerCallback();
      }
    }
  } catch (e) {
    console.error(e);
  }
};
